import { create } from 'zustand';
import { getMusicGenre } from '../services';

export interface GenreOption {
  label: string;
  value: string;
}

interface GenreState {
  // 数据
  genreOptions: GenreOption[];
  isLoaded: boolean;
  isLoading: boolean;
  
  // Actions
  fetchGenres: () => Promise<void>;
  reset: () => void;
}

export const useGenreStore = create<GenreState>((set, get) => ({
  genreOptions: [],
  isLoaded: false,
  isLoading: false,

  fetchGenres: async () => {
    // 如果已加载或正在加载，跳过
    if (get().isLoaded || get().isLoading) return;
    
    set({ isLoading: true });
    
    try {
      const res: any = await getMusicGenre();
      const genreMap = res?.genreMap || res?.data?.genreMap || {};
      
      // 转换为 options 格式
      const genreOptions: GenreOption[] = Object.entries(genreMap).map(([id, name]) => ({
        label: name as string,
        value: id,
      }));
      
      set({
        genreOptions,
        isLoaded: true,
        isLoading: false,
      });
    } catch (error) {
      console.error('Failed to fetch genres:', error);
      set({ isLoading: false });
    }
  },

  reset: () => set({
    genreOptions: [],
    isLoaded: false,
    isLoading: false,
  }),
}));

// 便捷函数
export const getGenreOptions = () => useGenreStore.getState().genreOptions;
export const fetchGenresIfNeeded = () => useGenreStore.getState().fetchGenres();
